__turbopack_context__.v({
  "component": "style-module-scss-module__FUqZMa__component",
  "downArrowIcon": "style-module-scss-module__FUqZMa__downArrowIcon",
  "downArrowWrapper": "style-module-scss-module__FUqZMa__downArrowWrapper",
  "floatingPulse": "style-module-scss-module__FUqZMa__floatingPulse",
  "mask": "style-module-scss-module__FUqZMa__mask",
  "text": "style-module-scss-module__FUqZMa__text",
  "videoContainer": "style-module-scss-module__FUqZMa__videoContainer",
});
